import { Heading as OriginalComponent } from './Heading';

export const Heading = OriginalComponent;



// WEBPACK FOOTER //
// ./app/components/Heading/index.js